// Sample videos in the Style Profile, one list per kind of video (Ryan, 2026-09-26): the ONLY place that knows their
// field names and words. The profile page, the setup wizard and the read-only views read and write through it. The
// server's AI Style Notes use the same fields and words (backend/app/style_notes/profile.py: SAMPLES, SAMPLE_LABELS,
// FALLBACK), and tests/test_samples_per_product.py holds the two copies together.

export const SAMPLE_KINDS = [
  { category: 'highlight', field: 'reference_videos', label: 'Highlight film samples', slots: 3, testid: 'highlight' },
  { category: 'doc_edit', field: 'doc_edit_reference_videos', label: 'Doc edit samples', slots: 2, testid: 'doc-edit' },
  { category: 'social', field: 'social_reference_videos', label: 'Social media video samples', slots: 2, testid: 'social' },
];

export const SAMPLES_HINT = "Links to videos you love, yours or anyone's.";

const FALLBACK = {
  doc_edit: 'Using your highlight samples as a guide to the look until you add doc edit samples.',
  social: 'Using your highlight samples as a guide to the look until you add social media video samples.',
};

/** The links a list holds, blanks left out. */
export function sampleLinks(video, field) {
  return ((video || {})[field] || []).filter(x => typeof x === 'string' && x.trim()).map(x => x.trim());
}

/** What a project of this kind is edited to: its own samples, else (a doc edit or social media video with none) the
 *  highlight film samples, with the sentence that says so as `fallback`. */
export function samplesFor(video, category) {
  const kind = SAMPLE_KINDS.find(k => k.category === category) || SAMPLE_KINDS[0];
  const own = sampleLinks(video, kind.field);
  if (own.length || !FALLBACK[kind.category]) return { kind, links: own, fallback: null };
  const highlight = sampleLinks(video, SAMPLE_KINDS[0].field);
  return highlight.length ? { kind: SAMPLE_KINDS[0], links: highlight, fallback: FALLBACK[kind.category] }
    : { kind, links: [], fallback: null };
}

/** Every list at least as long as its slots, for the forms. A longer saved list keeps all its links. */
export function withSampleSlots(video) {
  const out = { ...(video || {}) };
  for (const k of SAMPLE_KINDS) {
    const cur = Array.isArray(out[k.field]) ? out[k.field] : [];
    out[k.field] = cur.length >= k.slots ? [...cur] : [...cur, ...Array(k.slots - cur.length).fill('')];
  }
  return out;
}
